import { useState } from 'react'

import { useAdFree } from 'hooks/adFree'
import { useAppSelector } from 'redux/hooks'

import Icon from 'components/elements/Icon'

import styles from './inhouseVideoAd.module.scss'

export const VideoAd = () => {
  const adFree = useAdFree()

  const canary = useAppSelector(state => state.active.canary)

  const [closed, setClosed] = useState(false)

  if (!canary) return null
  if (adFree) return null
  if (closed) return null

  return (
    <div className={styles.videoContainer} id="demo-video-player">
      <button className={styles.close} onClick={() => setClosed(true)}>
        <Icon name="close" />
      </button>
      <div className={styles.videoAd}>Video ad goes here</div>
    </div>
  )
}
